import { createContext, useState } from "react";

export const SideMenuContext = createContext();

export const SideMenuProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <SideMenuContext.Provider value={{ isOpen, toggleMenu, closeMenu}}>
      {children}
    </SideMenuContext.Provider>
  );
}